// frontend-react/src/pages/ForgotUsername.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api'; // Χρησιμοποίησε το api instance σου
import './LoginPage.css'; // Χρησιμοποιούμε τα ίδια styles

const ForgotUsername = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');
        try {
            // Δημιουργούμε ένα ξεχωριστό api call για αυτό
            const response = await api.post('/auth/forgot-username', { email });
            setMessage(response.data.message);
        } catch (error) {
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page-wrapper">
            <div className="login-container">
                <h1>ALGOSTOCK CAPITAL</h1>
                <h2>Recover Username</h2>
                
                {!message ? (
                    <form onSubmit={handleSubmit} className="login-form">
                        <p style={{color: 'var(--text-secondary)', fontSize: '0.9rem'}}>
                            Enter your email address and we'll send you your username.
                        </p>
                        <div className="input-group">
                           {/* Μπορείς να προσθέσεις ένα FiMail icon εδώ αν θέλεις */}
                            <input
                                type="email"
                                placeholder="Your Email Address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" disabled={loading}>
                            {loading ? 'Sending...' : 'Send Username Reminder'}
                        </button>
                    </form>
                ) : (
                    <p className="success-message">{message}</p>
                )}

                {error && <p className="error-message">{error}</p>}
                
                <div className="auth-link" style={{ marginTop: '2rem' }}>
                    <Link to="/login">← Back to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotUsername;